import React, { useState, useEffect } from "react";
import LoadingPage from "../../../services/LoadingPage";
import * as _ from "lodash";
import RevInvoicePrint from "./RevInvoicePrint";
import { getInfoInvPrint, getInvData } from "../ShareFunctionsPrint";
import InvCompanyCon from "../invCompany/InvCompanyCon";
import MaintancInvCon from "../maintaince/MaintancInvCon";
import TempleteInvCon from "../Inv_Tempalte/TempleteInvCon";
import BillTempletesCon from "../bill-template/BillTempletesCon";
import EnglishInvPrint from "../EnglishInv/EnglishInvPrint";
import DeleveryNotesPrint from "../DeliveryNotes/DeleveryNotesPrint";

function RevInvCon(props) {
    const { typeInv, openDelevery,locInv,foundData,setFoundData,sta,setSta} = props;
    // const [found, setFound] = useState({});
    // const [sta, setSta] = useState({});
    // const [inv, setInv] = useState(locInv?.invs);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const omlat = typeInv == 2 ? true : false;
    const empFound = typeInv == 4 ? true : false;

    useEffect(() => {
        setTimeout(async () => {
            await getInfoInvPrint(locInv, setData, setSta,  premiApp, omlat, empFound,true,foundData,setFoundData);
            // await getInvData(setInv, locInv.proc_id);
            setLoading(false);
        }, 0);
    }, []);
    if (!foundData.found || !sta || loading) return <LoadingPage />;
    return (
        <div>
            {openDelevery ? <DeleveryNotesPrint {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} />:
                <>
                    {typeInv == 2 ? <InvCompanyCon {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} /> :
                     typeInv == 3 ? <MaintancInvCon {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} /> :
                     typeInv == 4 ? <TempleteInvCon {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} /> :
                     typeInv == 5 ? <BillTempletesCon {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} /> :
                     typeInv == 6 ? <EnglishInvPrint {...{ locInv, found:foundData?.found , sta, inv:locInv?.invs, data, premiApp }} /> :
                           <RevInvoicePrint {...{ locInv, found:foundData?.found, sta, inv:locInv?.invs, data, premiApp }} />}
                </>}

        </div>
    );
}
export default RevInvCon;
